export default __webpack_public_path__ + "b7dfd96a570da65c7ee7a5503c4de0ae.png";